<div class="w-100 bg-blue d-flex">
    <mat-form-field class="bg-light col-2 admin-search-input">
        <input matInput placeholder="Search Credit Union" id="search-input" autocomplete="nope"
               [(ngModel)]="searchFilter"
               (ngModelChange)="onSearchChange($event)"/>
        <button
                mat-button
                *ngIf="searchFilter"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="onSearchChange(searchFilter = '')"
        >
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
    <div class="col-1"></div>
    <div class="col">
        <section [ngSwitch]="mode">
            <ng-container *ngSwitchCase="'edit'" [ngTemplateOutlet]="editTemplateCU"></ng-container>
        </section>
    </div>
    <div class="col text-right addUserBtn">
        <section [ngSwitch]="mode">
            <ng-container *ngSwitchCase="'edit'" [ngTemplateOutlet]="editTemplateAddUser"></ng-container>
        </section>
    </div>
</div>
<section class="row credit-union-container" [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'list'" [ngTemplateOutlet]="listTemplate"></ng-container>
    <ng-container *ngSwitchCase="'edit'" [ngTemplateOutlet]="editTemplate"></ng-container>
    <ng-container *ngSwitchCase="'table'" [ngTemplateOutlet]="tableTemplate"></ng-container>
</section>

<ng-template #listTemplate>
    <mat-card *ngFor="let cu of creditUnions | async | filter: searchFilter:['cuid', 'name'] | orderBy:'cuid'"
              (click)="selectActiveCreditUnion(cu)">
        <mat-card-header>
            <mat-card-title>{{cu.cuid}} - {{cu.name}}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>{{cu.addressLine1}}</div>
            <div>{{cu.city}},{{cu.state}} {{cu.zip1}}</div>
        </mat-card-content>
    </mat-card>
</ng-template>

<ng-template #editTemplate>
    <section class="d-flex edit-credit-union-container">

        <mat-card class="list">
            <mat-card-header>
                <mat-card-title>Current User</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <mat-form-field class="col">
                    <input matInput placeholder="Search" id="user-search-input" autocomplete="nope"
                           [(ngModel)]="userSearchFilter"
                    />
                    <button
                            mat-button
                            *ngIf="userSearchFilter"
                            matSuffix
                            mat-icon-button
                            aria-label="Clear"
                            (click)="userSearchFilter = ''"
                    >
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-list role="list" id="user-list">
                    <mat-list-item role="listitem"
                                   *ngFor="let user of activeCreditUnionPortalUsers| async | filter: userSearchFilter:['email', 'firstName','lastName'] "
                                   (click)="onPortalUserChange(user)"
                                   [ngClass]="{active: user?.username === selectedPortalUserInfo?.username}">
                        <div class="row">
                            <span class="col-12">{{user.firstName}} {{user.lastName}}</span>
                            <span class="col-12">{{user.email}}</span>
                        </div>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </mat-card>

        <mat-card class="info">
            <mat-card-header>
                <mat-card-title>User Information</mat-card-title>
                <div class="col" *ngIf="loginService.activeUser?.superAdmin">
                    <button
                            mat-button
                            matSuffix
                            mat-icon-button
                            aria-label="Delete User"
                            (click)="deleteUser()"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </mat-card-header>
            <form [formGroup]="FormHelper.UserForm">
                <mat-card-content class="d-flex margin-top-15">

                    <div class="col-5 ">

                        <h5 class="text-left border-bottom">User Details</h5>
                        <div>
                            <mat-form-field class="col-10">
                            <span class="astrick">*</span>
                                <mat-label class="text-uppercase">Username</mat-label>
                                <input matInput type="text" id="username" class="form-control"
                                       formControlName="username"
                                       [ngModel]="selectedPortalUserInfo?.username">
                            </mat-form-field>
                            <mat-form-field class="col-10">
                                <span class="astrick">*</span>
                                <mat-label class="text-uppercase">First Name</mat-label>
                                <input matInput type="text" id="firstname" class="form-control"
                                       formControlName="firstname"
                                       [ngModel]="selectedPortalUserInfo?.firstName">
                            </mat-form-field>

                            <mat-form-field class="col-10">
                                <span class="astrick">*</span>
                                <mat-label class="text-uppercase">Last Name</mat-label>
                                <input matInput type="text" id="lastname" class="form-control"
                                       formControlName="lastname"
                                       [ngModel]="selectedPortalUserInfo?.lastName">
                            </mat-form-field>

                            <mat-form-field class="col-10">
                                <mat-label class="text-uppercase">Title</mat-label>
                                <input matInput type="text" id="title" class="form-control" formControlName="title"
                                       [ngModel]="selectedPortalUserInfo?.title">
                            </mat-form-field>

                            <mat-form-field class="col-10">
                                <span class="astrick">*</span>
                                <mat-label class="text-uppercase">Email</mat-label>
                                <input matInput id="emailAddress" class="form-control" formControlName="emailAddress"
                                       type="text"
                                       [ngModel]="selectedPortalUserInfo?.emailAddress">
                            </mat-form-field>

                            <mat-form-field class="col-10">
                                <span class="astrick">*</span>
                                <mat-label class="text-uppercase">Phone Number</mat-label>
                                <input matInput type="text" id="phonenumber" class="form-control"
                                       formControlName="phonenumber"
                                       [ngModel]="selectedPortalUserInfo?.phoneNumber">
                            </mat-form-field>
                        </div>

                    </div>
                    <div class="col-5 d-block">
                        <div>
                            <h5 class="text-left border-bottom">Dates</h5>
                            <div>
                                <mat-form-field class="col-10 offset-1">
                                    <mat-label class="text-uppercase">Created Date</mat-label>
                                    <input matInput type="text" id="createddate" class="form-control"
                                           formControlName="createddate" [readonly]="true"
                                           [ngModel]="selectedPortalUserInfo?.createdDate | date: 'M/dd/yyyy hh:mm a'">
                                </mat-form-field>
                                <mat-form-field class="col-10 offset-1">
                                    <mat-label class="text-uppercase">Last Login Date</mat-label>
                                    <input matInput type="text" id="lastlogindate" class="form-control"
                                           formControlName="lastlogindate" [readonly]="true"
                                           [ngModel]="selectedPortalUserInfo?.lastLoginDate | date: 'M/dd/yyyy hh:mm a'">
                                </mat-form-field>
                                <mat-form-field class="col-10 offset-1">
                                    <mat-label class="text-uppercase">Expiration Date</mat-label>
                                    <input matInput type="text" id="experationdate" class="form-control"
                                           formControlName="experationdate" [readonly]="true"
                                           [ngModel]="selectedPortalUserInfo?.expirationDate | date: 'M/dd/yyyy hh:mm a'">
                                </mat-form-field>
                            </div>
                        </div>

                        <div>
                            <h5 class="text-left border-bottom">Roles</h5>
                            <mat-radio-group required formControlName="role"
                                             class="d-block col-10 offset-2 p-0" id="role-group"
                                             [ngModel]="getRole(selectedPortalUserInfo)">
                                <mat-radio-button class="col" *ngFor="let role of roles" [value]="role.value">
                                    {{role.label}}
                                </mat-radio-button>
                            </mat-radio-group>
                            <div class="text-right">
                                <button class="updateBTN" mat-raised-button [color]="'primary'" (click)="editUser()"
                                        *ngIf="loginService.activeUser?.superAdmin"
                                        [disabled]="(!FormHelper.UserForm.valid)">Update User
                                </button>
                                <button class="resetBTN" mat-raised-button [color]="'primary'"
                                        (click)="resetPassword()">Reset Password
                                </button>

                            </div>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </mat-card>

    </section>
</ng-template>

<ng-template #tableTemplate>
    <div class="portal-user-table">
        <mat-form-field class="col-12">
            <mat-label>Filter</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Search">
        </mat-form-field>
        <button id="export-button" mat-raised-button *ngIf="loginService.activeUser?.superAdmin" (click)="export()"
                [color]="'primary'">Export
        </button>
        <table mat-table [dataSource]="dataSource" matSort class="table">
            <ng-container [matColumnDef]="column.value" *ngFor="let column of displayedColumns">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{column.label}} </th>
                <td mat-cell *matCellDef="let element"
                    (click)="onClickAllPortalUserRow(element)" [ngSwitch]="true">
                    <span *ngSwitchCase="column.value === 'expirationDate'">
                        {{element['expirationDate'] |date: 'M/dd/yyyy'}}
                    </span>
                    <span *ngSwitchDefault>{{element[column.value]}}</span>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns" class="w-100"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" class="w-100"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,25,50,100, dataSource.data.length]"></mat-paginator>
    </div>
</ng-template>

<ng-template #editTemplateAddUser>
    <div *ngIf="loginService.activeUser?.superAdmin">
        <button
                mat-button
                matSuffix
                mat-icon-button
                aria-label="Add User"
                (click)="addUser()"
                id="add-user"
        >
            <mat-icon>add</mat-icon>

        </button>
    </div>
</ng-template>

<ng-template #editTemplateCU>
    <p class="cuNameandID">{{activeCreditUnion.cuid}} - {{activeCreditUnion.name}}</p>
</ng-template>
